<template>
<Head :title="title" />

    <jet-banner />
    <div class="flex flex-col"> 
         <!-- header  --> 
         <bernstein-header> </bernstein-header>
         <app-layout >
          <!-- native header  -->
          
          
          <!-- ******************************************************************************************************** -->
          <!-- middle and main part of the web  -->
           <div class="py-6 px-4 sm:px-6 lg:px-8">
                 <slot class="flex-grow  " > </slot>
          </div>
           <!-- Here is the bernstein footer  -->
         </app-layout> 
         
          <bernstein-footer > </bernstein-footer>
    </div>
</template>
<script>
    import JetBanner from '@/Jetstream/Banner.vue'
    import BernsteinHeader from "@/Jetstream/BernsteinHeader";
    import BernsteinFooter from "@/Jetstream/BernsteinFooter";
    import AppLayout from './AppLayout.vue';
    
  export default{
      
      props:{
        loggedIn: Boolean 
      }, 
      data(){

      },
      components: {
          JetBanner,
          BernsteinHeader,
          BernsteinFooter,
            AppLayout
      }
  }
 </script>
